import React, { Component } from 'react'
import ReactDom from 'react-dom'

import Landing from './components/landing.js'
import Vita from './components/vita.js'
import Works from './components/works.js'
import Contact from './components/contact.js'
import Menu from './components/menu.js'
import MenuDiary from './components/menudiary.js'
import Publication from './components/publication.js'
import Blog from './components/blog.js'

import Diary from './components/diary.js'

import { parsePath } from './helper.js'

import './css/app.css'

class Site extends Component {
  render() {
    const { category, slug } = parsePath(this.props.path)
    let content = <Landing />
    switch (category) {
      case '':
        content = <Landing />
        break
      case 'vita':
      case 'autorin':
        content = <Vita />
        break
      case 'publikationen':
        content = <Works />
        break
      case 'contact':
      case 'kontakt':
        content = <Contact />
        break
      case 'publications':
      case 'texte':
        content = <Publication slug={slug} />
        break
      case 'diary':
        content = <Blog slug={slug} hash={this.props.hash} />
        break
      default:
        content = <Landing />
        break
    }
    return (
      <div className="site">
        {category !== 'diary' ? (
          <Menu category={category} slug={slug} hash={this.props.hash} />
        ) : (
          <MenuDiary category={category} slug={slug} hash={this.props.hash} />
        )}
        <div id="main" className={'main main--' + category}>
          {content}
        </div>
        <Diary category={category} />
      </div>
    )
  }
}

renderApp(window.location.pathname, window.location.hash)

window.addEventListener('popstate', function(e) {
  // render page when path changes
  renderApp(window.location.pathname, window.location.hash)
})

function renderApp(path, hash) {
  ReactDom.render(
    <Site path={path} hash={hash} />,
    document.getElementById('dj')
  )
}



// WEBPACK FOOTER //
// ./src/front/index.js